import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_3"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 71.6 88.9"
    style={{
      enableBackground: "new 0 0 71.6 88.9",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        `\n\t.slb_st0{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.slb_st1{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0008;}\n\t.slb_st2{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0006;}\n\t.slb_st3{fill:none;stroke:${strokeColor};stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:3.9996;}\n`
      }
    </style>
    <path className="slb_st0" d="M49.2,86.7c0,0-25.7-24.3-30.9-29.5" />
    <path className="slb_st0" d="M15.8,22l-0.2,3.8c0,0.5-0.7,0.8-1.2,0.8L10,26.1c-1.6-0.2-2.7-1.2-2.6-2.4l0,0c0-1.2,1.2-2.1,2.9-2.3l4.4-0.2 C15.2,21.3,15.8,21.7,15.8,22L15.8,22z" />
    <path className="slb_st0" d="M36.9,3.3c-4.3,1-20.8,21.1-20.7,20.5C14.9,22,27.1,8,35.6,1.8" />
    <path className="slb_st0" d="M18.2,21.8l-2.4,4.7c0,0-3.3,22,1.7,30.4" />
    <path className="slb_st0" d="M59.5,6c0,0-9.8,30.1-12.3,33.1c-2.4,7.3-2.4,4-3.1,17.3c0,0.7-0.5,11.9,0.4,25.8" />
    <path className="slb_st0" d="M15.8,56.8l-0.1-0.4c0,0,1.3,0,2.6,0.9" />
    <path className="slb_st0" d="M12.5,67.5l7.5-1.4c1.4-0.3,2.3-1.3,2.4-2.5l0.1-1.9" />
    <path className="slb_st0" d="M3.1,48.4c0,0-1.7-14.5,3.1-12.6c0,0,5.4,2.4,9.2,18.9c0.9,3.7,0.8,6.8,0.1,8.9" />
    <path className="slb_st0" d="M8.6,65c-2.7-3.7-4-9.9-4-9.9l-1.4-1.2c0.2-0.8-0.2-6.4-0.6-8.5c0-0.3-0.2-0.8-0.2-1.1 c0.4-8.9-0.1-12.2,1.1-13.6c0.2-0.3,1.6-2.8,2.7-3.9c0.3-0.7,1.2-1.1,2-1.4c1,0.5,5,1.4,5.1,1c0,0,1.4-0.1,2.2-0.7" />
    <ellipse transform="matrix(0.9846 -0.1748 0.1748 0.9846 -8.9947 2.4343)" className="slb_st1" cx="9.3" cy="52.3" rx="4.2" ry="11.9" />
    <path className="slb_st0" d="M6.2,36.1c0,0-4.2,8.3-1.5,19.4" />
    <ellipse transform="matrix(0.9878 -0.1557 0.1557 0.9878 -8.183 2.0857)" className="slb_st2" cx="9.2" cy="53.3" rx="1.1" ry="2.6" />
    <path className="slb_st0" d="M15.6,63.1c-0.2,1.4-2.5,8.3-7.3,1.5" />
    <polygon className="slb_st3" points="32.8,37.8 27,35.6 26.3,37.1 32.1,39.2 " />
    <line className="slb_st0" x1="31.3" y1="37.2" x2="30.6" y2="38.7" />
    <ellipse className="slb_st0" cx="31.7" cy="38.2" rx="0.5" ry="0.4" />
    <line className="slb_st0" x1="15.9" y1="26.5" x2="68.6" y2="40.6" />
  </svg>
);
export default SvgComponent;
